import React from "react";
import { useDelayedEffect } from "../Hooks/useDelayedEffect";
import { useGlobalHotkey } from "../Hooks/useHotkey/useHotkey";
import { toModifierArray } from "./Common";
/**
 * Adds a hotkey that will be active regardless of where focus is on the page (event listener is added to document).
 * Remains active as long as this component is rendered
 * @param props GlobalHotkeyProps
 * @returns a JSX element
 */
export function GlobalHotkey(props) {
    //see Hotkey for more detailed explanation of what's going on here
    const { onDown } = props;
    const modifiers = toModifierArray(props);
    const triggerOnDown = useDelayedEffect(onDown, props.triggerBlur ?? false);
    useGlobalHotkey(triggerOnDown, props.hotkey, props.triggerBlur, ...modifiers);
    return React.createElement(React.Fragment, null, props.children);
}
